import type { ContainCoverFit } from './contracts';

export function parseContainCoverFit(value: unknown, path: string): ContainCoverFit {
    if (value !== 'contain' && value !== 'cover') {
        throw new Error(`Expected "${path}" to be either "contain" or "cover".`);
    }

    return value;
}
